module.exports = __webpack_public_path__ + "static/img/no_data_default.0f693af4.png";